export default {
	SET_ALBUM(state, payload) {
		state.album = payload;
	}, SET_PHOTO(state, payload) {
		state.album.photos[payload.index] = payload.data;
	}, SET_UPLOAD(state, payload) {
		state.album = payload;
	}, SET_ALBUM_LIST(state, payload) {
		state.list = payload;
	}
};



// WEBPACK FOOTER //
// ./sources/app/gallery/mutations.js